import React from 'react';

import styles from '../../styles/views/components/CheckInbox.module.scss';

const CheckInbox = () => (
  <>
    <h1 className={styles.header}>Check your inbox!</h1>
    <p className={styles.paragraph}>
      We have now sent a Bookmaker password reset email to your inbox.
      <br />
      Please open the email and follow the link to set a new password.
    </p>
    <div className={styles.noteWrapper}>
      <p>
        <span>Important Note:</span> The password reset link is time-sensitive and will expire after a specific period (24 hours) for security purposes.
      </p>
    </div>
  </>
);

export default CheckInbox;
